import React from "react";
import DotsMenu from "./DotsMenu";

/**
 * Generic white analytics card with a title + 3-dot menu header.
 *
 * @param {string}    title
 * @param {ReactNode} children
 * @param {ReactNode} [extra]       Additional header content (e.g. tab buttons)
 * @param {string}    [className]   Extra CSS classes on the root element
 * @param {object}    [style]       Inline style overrides on the root element
 * @param {Function}  [onMenuClick] Called when the 3-dot menu is clicked
 */
const SectionCard = ({
  title,
  children,
  extra,
  className = "",
  style = {},
  onMenuClick,
}) => (
  <div
    className={`rounded-3 p-3 h-100 ${className}`}
    style={{
      background: "#fff",
      border: "1px solid #F2F4F7",
      boxShadow: "0 1px 3px rgba(16,24,40,0.06)",
      ...style,
    }}
  >
    <div className="d-flex justify-content-between align-items-center mb-3">
      <span
        className="fw-semibold"
        style={{ color: "#101828", fontSize: "0.88rem" }}
      >
        {title}
      </span>
      <div className="d-flex align-items-center gap-2">
        {extra}
        <button
          className="btn p-0"
          style={{ background: "transparent", border: "none" }}
          onClick={onMenuClick}
          aria-label="More options"
        >
          <DotsMenu />
        </button>
      </div>
    </div>
    {children}
  </div>
);

export default SectionCard;
